import React from 'react';

export const DialectIcon = (props) => (
   <svg
    className="svg-icon"
    style={{
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden",
    }}
    viewBox="0 0 1024 1024"
    id="svg4"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs id="defs8">
      <rect
        x={164.88136}
        y={234.30508}
        width={724.61017}
        height={624.81356}
        id="rect222"
      />
    </defs>
    <g
      id="g29516"
      style={{
        strokeWidth: 30,
        strokeDasharray: "none",
      }}
      transform="matrix(0.99848231,0,0,1.1022552,0.77594069,-51.106252)"
    >
      <path
        style={{
          display: "inline",
          overflow: "hidden",
          fill: "#ffffff",
          fillOpacity: 1,
          stroke: "#000000",
          strokeWidth: 30,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeDasharray: "none",
          strokeOpacity: 1,
        }}
        d="m 160.04473,956.56056 703.44951,-0.1494 V 520.39982 c -67.99925,0.43534 -585.36733,0.53842 -703.30732,1.00754 l -2.14739,143.06794 -132.083045,66.03543 132.047945,82.5435 z"
        id="path751-2-3"
      />
      <text
        xmlSpace="preserve"
        style={{
          fontStyle: "normal",
          fontVariant: "normal",
          fontWeight: "bold",
          fontStretch: "normal",
          fontSize: "520.54px",
          lineHeight: 1.25,
          fontFamily: "Candara",
          InkscapeFontSpecification: "'Candara, Bold'",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          letterSpacing: 0,
          wordSpacing: 0,
          display: "inline",
          overflow: "hidden",
          fill: "#4d4d4d",
          strokeWidth: 31.152,
          strokeDasharray: "none",
        }}
        x={181.72581}
        y={916.20007}
        id="text1786"
        transform="scale(1.0433425,0.95845805)"
      >
        <tspan
          id="tspan1784"
          x={181.72581}
          y={916.20007}
          style={{
            fontStyle: "normal",
            fontVariant: "normal",
            fontWeight: "normal",
            fontStretch: "normal",
            fontSize: "520.54px",
            fontFamily: "Arial",
            fill: "#4d4d4d",
            strokeWidth: 31.152,
            strokeDasharray: "none",
          }}
        >
          {"\u0259\u028A"}
        </tspan>
      </text>
    </g>
    <g
      id="g29510"
      transform="matrix(0.99848231,0,0,1.1022552,0.77594069,-73.151356)"
      style={{
        strokeWidth: 30,
        strokeDasharray: "none",
      }}
    >
      <path
        style={{
          display: "inline",
          overflow: "hidden",
          fill: "#ffffff",
          fillOpacity: 1,
          stroke: "#000000",
          strokeWidth: 30,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeDasharray: "none",
          strokeOpacity: 1,
        }}
        d="m 862.48643,519.36402 -703.4495,-0.1494 V 83.203276 c 67.9992,0.43534 585.36732,0.53842 703.30731,1.00754 l 2.14739,143.067944 132.08305,66.03543 -132.04795,82.5435 z"
        id="path751-2-3-8"
      />
      <text
        xmlSpace="preserve"
        style={{
          fontStyle: "normal",
          fontVariant: "normal",
          fontWeight: "bold",
          fontStretch: "normal",
          fontSize: "509.574px",
          lineHeight: 1.25,
          fontFamily: "Candara",
          InkscapeFontSpecification: "'Candara, Bold'",
          fontVariantLigatures: "normal",
          fontVariantCaps: "normal",
          fontVariantNumeric: "normal",
          fontVariantEastAsian: "normal",
          letterSpacing: 0,
          wordSpacing: 0,
          display: "inline",
          overflow: "hidden",
          fill: "#4d4d4d",
          strokeWidth: 30.8941,
          strokeDasharray: "none",
        }}
        x={186.75516}
        y={472.99646}
        id="text1786-8"
        transform="scale(1.0504258,0.95199489)"
      >
        <tspan
          id="tspan1784-3"
          x={186.75516}
          y={472.99646}
          style={{
            fontStyle: "normal",
            fontVariant: "normal",
            fontWeight: "normal",
            fontStretch: "normal",
            fontSize: "509.574px",
            fontFamily: "Arial",
            fill: "#4d4d4d",
            strokeWidth: 30.8941,
            strokeDasharray: "none",
          }}
        >
          {"o\u028A"}
        </tspan>
      </text>
    </g>
  </svg>
);
